import { render } from "./Attr.vue?vue&type=template&id=5ab31008&scoped=true"
import script from "./Attr.vue?vue&type=script&lang=js"
export * from "./Attr.vue?vue&type=script&lang=js"

import "./Attr.vue?vue&type=style&index=0&id=5ab31008&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab31008"],['__file',"src/components/widgets/components_core/Attr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ab31008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ab31008', __exports__)) {
    api.reload('5ab31008', __exports__)
  }
  
  module.hot.accept("./Attr.vue?vue&type=template&id=5ab31008&scoped=true", () => {
    api.rerender('5ab31008', render)
  })

}


export default __exports__